import { Link } from 'react-router-dom';
import React from 'react';
import Container from '../../styled/Container';
import { HeaderWrapper, HeaderInner } from './Header.styles';
import tableskitLogo from '../../assets/logo.png';
// import Icon from '../../styled/Icon/Icon';

const Header: React.FC = () => (
  <HeaderWrapper>
    <Container>
      <HeaderInner>
        <Link to="/">
          <figure className="headerLogo">
            <img src={tableskitLogo} alt="tables kit logo" />
          </figure>
        </Link>
        {/* <nav>
          <Link to="/custom">
            <div className="headerMenuItem">
              <Icon type="cog" />
              <span>Settings</span>
            </div>
          </Link>
        </nav> */}
      </HeaderInner>
    </Container>
  </HeaderWrapper>
);

export default Header;
